import { HttpClient, provideHttpClient, withInterceptors, withXhr } from '@angular/common/http';
import { ApplicationConfig, ErrorHandler, Injectable, importProvidersFrom, inject, isDevMode } from '@angular/core';
import { provideNativeDateAdapter } from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { authHttpInterceptorFn, provideAuth0 } from '@auth0/auth0-angular';
import { Translation, TranslocoLoader, provideTransloco } from '@jsverse/transloco';
import { CookieService } from 'ngx-cookie-service';
import { environment } from '../environments/environment';
import { mainRoutes } from './app.routes';
import { httpResilienceInterceptor } from './core/interceptors/http-resilience.interceptor';
import { API_BASE_URL } from './core/services/dataservice.svc';
import { LoggingErrorHandler } from './core/services/logging-error-handler.service';
import { ApplicationInsightsService } from './core/services/telemetry.service';
import { UserResolverService } from './core/services/user-resolver.service';
import { VersionCheckService } from './core/services/version-check.service';
import { SpinnerService } from './core/spinner/spinner.service';

@Injectable({ providedIn: 'root' })
export class TranslocoHttpLoader implements TranslocoLoader {
    private http = inject(HttpClient);

    getTranslation(lang: string) {
        return this.http.get<Translation>(`/assets/i18n/${lang}.json`);
    }
}

export const appConfig: ApplicationConfig = {
    providers: [
        importProvidersFrom(BrowserModule),
        {
            provide: ErrorHandler,
            useClass: LoggingErrorHandler
        },
        {
            provide: API_BASE_URL,
            useValue: environment.backendServerUrl
        },
        CookieService,
        VersionCheckService,
        UserResolverService,
        ApplicationInsightsService,
        SpinnerService,
        provideNativeDateAdapter(),
        provideRouter(mainRoutes),
        provideAuth0({ ...environment.auth }),
        provideHttpClient(withXhr(), withInterceptors([authHttpInterceptorFn, httpResilienceInterceptor])),
        provideTransloco({
            config: {
                availableLangs: ['en', 'es', 'fil'],
                defaultLang: 'en',
                // Remove this option if your application doesn't support changing language in runtime.
                reRenderOnLangChange: true,
                prodMode: !isDevMode()
            },
            loader: TranslocoHttpLoader
        })
    ]
};
